<script lang="ts">
    import Vue from "vue";
    import { Component } from 'vue-facing-decorator';

    @Component({
        props: {
            propOpened: { type: Boolean, required: true, default: false },
            propSurveyStarted: { type: Boolean, required: true },
            propAutoRevealEnabled: { type: Boolean, required: true },
            propNamesRevealed: { type: Boolean, required: true },
        }
    })
    export default class MeetingStarterDialog extends Vue
    {
        get opened(): boolean { return this.$props.propOpened; }
        get surveyStarted(): boolean { return this.$props.propSurveyStarted; }
        get autoRevealEnabled(): boolean { return this.$props.propAutoRevealEnabled; }
        get namesRevealed(): boolean { return this.$props.propNamesRevealed; }

        startMeeting()
        {
            this.$emit('start-meeting');
        }

        startSurvey()
        {
            this.$emit('start-survey');
        }

        stopSurvey()
        {
            this.$emit('stop-survey');
        }

        toggleAutoReveal()
        {
            this.$emit('toggle-auto-reveal');
        }

        toggleNamesRevealed()
        {
            this.$emit('toggle-names-revealed');
        }

        showAccessLinks()
        {
            this.$emit('show-access-links');
        }

        close()
        {
            this.$emit('close-dialog');
        }
    }

</script>

<template>
    <div class="modal-mask" v-if="opened">
        <div class="modal-wrapper">
            <div class="modal-dialog modal-lg modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Set up your meeting​</h5>
                        <button type="button" class="close" @click="close">&times;</button>
                    </div>

                    <div class="modal-body">
                        <p class="lead">
                            Before you start your real-time meeting, let’s make sure everything is ready.
                            <strong>You can change any of these settings during the meeting.</strong>
                        </p><br />

                        <table class="table">
                            <tbody>
                                <tr v-if="surveyStarted === true">
                                    <td>
                                        <h5>Survey is open</h5>
                                        <p>Your team can change their answers to <strong>ANY question</strong> during the meeting. </p>
                                    </td>
                                    <td class="align-middle">
                                        <button class="btn btn-outline-success btn-block text-nowrap" @click="stopSurvey">Close survey</button>
                                    </td>
                                </tr>
                                <tr v-if="surveyStarted === false">
                                    <td>
                                        <h5>Survey is closed</h5>
                                        <p>Your team will only be able to change their answers for the <strong>question you’re on.</strong></p>
                                    </td>
                                    <td class="align-middle">
                                        <button class="btn btn-outline-secondary btn-block text-nowrap" @click="startSurvey">Open survey</button>
                                    </td>
                                </tr>
                                <tr v-if="autoRevealEnabled === true">
                                    <td>
                                        <h5>Auto reveal is ON</h5>
                                        <p>When you move from question to question, your meeting participants WILL be able to see each others’ votes.​</p>
                                    </td>
                                    <td class="align-middle">
                                        <button class="btn btn-outline-secondary btn-block text-nowrap" @click="toggleAutoReveal">Turn off</button>
                                    </td>
                                </tr>
                                <tr v-if="autoRevealEnabled === false">
                                    <td>
                                        <h5>Auto reveal is OFF</h5>
                                        <p>When you move to the next question, we will automatically hide everyone’s votes. This can help reduce “follow my leader” bias and “group think.”</p>
                                    </td>
                                    <td class="align-middle">
                                        <button class="btn btn-outline-secondary btn-block text-nowrap" @click="toggleAutoReveal">Turn on</button>
                                    </td>
                                </tr>
                                <tr v-if="namesRevealed === true">
                                    <td>
                                        <h5>Anonymous mode is OFF</h5>
                                        <p>When sharing votes, names WILL be displayed.​</p>
                                    </td>
                                    <td class="align-middle">
                                        <button class="btn btn-outline-secondary btn-block text-nowrap" @click="toggleNamesRevealed">Turn on</button>
                                    </td>
                                </tr>
                                <tr v-if="namesRevealed === false">
                                    <td>
                                        <h5>Anonymous mode is ON</h5>
                                        <p>When sharing votes, names WILL NOT be displayed.​</p>
                                    </td>
                                    <td class="align-middle">
                                        <button class="btn btn-outline-secondary btn-block text-nowrap" @click="toggleNamesRevealed">Turn off</button>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <h5>Access links</h5>
                                        <p>These links will let your participants join the meeting with just one click. Why not (re)send them now?​</p>
                                    </td>
                                    <td class="align-middle">
                                        <button class="btn btn-outline-secondary btn-block text-nowrap" @click="showAccessLinks">Access links</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div class="modal-footer">
                        <button @click="startMeeting" type="button" class="btn btn-primary">Start the meeting</button>
                        <button @click="close" type="button" class="btn btn-outline-secondary">Cancel</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>